export interface IProductPrice {
  originalPrice: number;
  afterDiscountPrice: number;
}

export interface ISize {
  length: number;
  breadth: number;
  height: number;
  weight: number;
}

export interface IProductImage {
  size: {
    width: Number;
    height: Number;
  };
  url: string;
  key: string;
}

export enum ProductType {
  SIMPLE = "Simple",
  VARIANT = "Variant",
}

export interface IProductCms {
  faqs: string;
  whatIsIt: string;
  whatsInIt?: string;
  howToUse?: string;
  subTitle?: String;
}

export enum ProductCmsNameValues {
  whatIsIt = "Description",
  whatsInIt = "Ingredients",
  howToUse = "How To Use",
  benefits = "benefits",
  whatExpertHasToSay = "What Expert Has To Say",
}
export enum ProductCmsNameKeys {
  whatIsIt = "whatIsIt",
  whatsInIt = "whatsInIt",
  howToUse = "howToUse",
  benefits = "benefits",
  whatExpertHasToSay = "whatExpertHasToSay",
}
export interface IProduct {
  _id: string;
  sku: string;
  name: string;
  slug?: string;
  image: IProductImage;
  media: IProductImage[];
  availableQuantity: number;
  maxQuantityAllowedInSignleCart: number;
  discount: number;
  price: number;
  categories: [string];
  aggregateRating?: IAggregateRating;
  relatedTo?: string[];
  similarTo?: string[];
  properties: Record<string, any>;
  type: ProductType;
  variantOf?: string;
  size: ISize;
  metaData?: {
    keywords: string[];
    description: string;
    title: string;
  };
  cms: IProductCms;
  inStock: boolean;
  finalPrice: number;
}

export interface IAggregateRating {
  ratingValue: number;
  ratingCount: number;
}

export interface IPagination {
  perPage: number;
  page: number;
  hasPrevious: boolean;
  hasNext: boolean;
  next: string;
  previous: string;
  totalCount: number;
}
